import styled from "styled-components"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H3, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import media, {minWidthMedia} from "@irati/ui/src/global/media"

interface CreditWrapperProps {
  fullWidth: boolean
}

export const CreditWrapper = styled.div<CreditWrapperProps>`
  width: 100%;
  ${minWidthMedia.desktop`
    width: 60%;
  `}
  ${({fullWidth}) => fullWidth && "width: 100% !important;"}
`

export const CreditAsRewardWrapper = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
  ${minWidthMedia.desktop`
    width: 38%;
  `}
`

export const Balances = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.desktop`
    padding-bottom: 10px;
  `}
  ${minWidthMedia.phoneLandscape`
    align-items: stretch;
    flex-direction: row;
  `}
  ${minWidthMedia.desktop`
    align-items: center;
    flex-direction: column;
  `}
`

export const Balance = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StyledButton = styled(ButtonRouterLink)`
  padding: ${({theme}) => theme.spacing.one};
  width: 100%;
  max-width: 210px;
`

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: ${({theme}) => theme.shadows.low};
  ${minWidthMedia.tablet`
    margin-top: 30px;
  `}
  ${minWidthMedia.desktop`
    margin-top: 30px;
    justify-content: space-between;
    flex-direction: row;
  `}
`

export const StyledCaption = styled(Label)`
  margin-top: 10px;
  text-transform: uppercase;
  font-size: 10px;
  color: ${({theme}) => theme.colors.greys.mediumDark};
`

export const AvailableBalance = styled(H3)`
  color: ${({theme}) => theme.colors.brand.default};
  font-size: 45px;
  line-height: 50px;
`
